import {createAction, props} from '@ngrx/store';
import {
  ContactNotificationSettingsDto,
  ContactNotificationSubject,
  FilterDto,
  NotificationListDto,
  NotificationSubjects
} from "@server-models";
import {ILocalPagination} from "@shared/interfaces/pagination.interface";

export interface ISharedNotificationListGetNotificationListPayload {
  filters?: FilterDto[],
  paging?: ILocalPagination,
}

export interface ISharedNotificationListGetNotificationListSuccessPayload {
  filters?: FilterDto[],
  paging: ILocalPagination,
  items: NotificationListDto[],
}

export const getNotificationList = createAction(
  '[Shared Notification List] Get Notification List',
  props<ISharedNotificationListGetNotificationListPayload>()
);

export const getNotificationListSuccess = createAction(
  '[Shared Notification List] Get Notification List Success',
  props<ISharedNotificationListGetNotificationListSuccessPayload>()
)

export const getNotificationListFail = createAction(
  '[Shared Notification List] Get Notification List Fail',
  props<{ error: Error }>()
)

export const startNotificationPollingInterval = createAction(
  '[Shared Notification List] Start Notification Polling Interval'
)

export const stopNotificationPollingInterval = createAction(
  '[Shared Notification List] Stop Notification Polling Interval'
)

export const notificationPollingSuccess = createAction(
  '[Shared Notification List] Notification Polling Success',
  props<{ count: number }>()
)

export const markAllAsRead = createAction(
  '[Shared Notification List] Mark All As Read'
)

export const getNotificationSettings = createAction(
  '[Shared Notification List] Get Notification Settings',
)

export const getNotificationSettingsSuccess = createAction(
  '[Shared Notification List] Get Notification Settings Success',
  props<{ settings: ContactNotificationSettingsDto }>()
)

export const getNotificationSettingsFail = createAction(
  '[Shared Notification List] Get Notification Settings Fail',
  props<{ error: Error }>()
)

export const setGlobalNotificationAllowance = createAction(
  '[Shared Notification List] Set Global Notification Allowance',
  props<{ allowance: boolean }>()
)

export const setGlobalNotificationAllowanceSuccess = createAction(
  '[Shared Notification List] Set Global Notification Allowance Success',
  props<{ settings: ContactNotificationSettingsDto }>()
)

export const setGlobalNotificationAllowanceFail = createAction(
  '[Shared Notification List] Set Global Notification Allowance Fail',
  props<{ error: Error }>()
)

export const setNotificationAllowanceForSubject = createAction(
  '[Shared Notification List] Set Notification Allowance For Subject',
  props<{ subject: ContactNotificationSubject, allowance: boolean }>()
)

export const setNotificationAllowanceForSubjectSuccess = createAction(
  '[Shared Notification List] Set Notification Allowance For Subject Success',
  props<{ settings: ContactNotificationSettingsDto }>()
)

export const setNotificationAllowanceForSubjectFail = createAction(
  '[Shared Notification List] Set Notification Allowance For Subject Fail',
  props<{ error: Error }>()
)
